import { render, staticRenderFns } from "./QuestionInformationVueComponent.vue?vue&type=template&id=b5a3cd6a&"
import script from "./QuestionInformationVueComponent.vue?vue&type=script&lang=ts&"
export * from "./QuestionInformationVueComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports